module.exports = __webpack_public_path__ + "d09e473f71f0eb9e35d5d591788d0e9a.png";